import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './NZCIListItem.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	title: string;
	value: string | number | React.ReactNode | React.ReactNode[];
	extra?: string;
	align?: boolean;
	button?: {
		title: string;
		onClick: () => void;
	};
	icon?: string;
}

const NZCIListItem: React.FC<Props> = ({
	title,
	value,
	extra,
	align,
	button,
	icon,
}) => {
	return (
		<div className={styles.wrapper}>
			<div
				className={joinClasses([
					styles.title,
					align ? styles.alignTitle : undefined,
				])}>
				<Text tx={title} inline firstUpper />:
			</div>
			{icon && (
				<div className={styles.iconWrapper}>
					<img src={icon} />
				</div>
			)}
			<div className={styles.value}>{value}</div>
			<div className={styles.extra}>{extra}</div>
			{button && (
				<div className={styles.buttonWrapper}>
					<Button
						theme={Theme.BLUE}
						onClick={button.onClick}
						title={button.title}
						small
					/>
				</div>
			)}
		</div>
	);
};

export default NZCIListItem;
